import React, { Component } from 'react';
import NavBar from '../../../_components/common/Navbar';

import TableNew from '../../../_components/common/TableNew';
import Settings from '../../../_components/common/SettingsHeader';
import { connect } from 'react-redux';
import ModalNew from '../../../_components/common/ModalNew';
import { addRelationGroups } from './relationGroupsFormData';

import { relationGroupstables } from './relationGrouptableColumns';
import { relationGroupsTableActions, addRelationGroupAction, getRelationList } from '../../../_actions';
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';

class RelationGroups extends Component {

    constructor(props) {
        super(props);

        this.state = {
            sortType: false,
            relationGroupData: '',
            modal: false,
            relationToggle: false,
            addRelationGroupState: false,
            addRelation: []
        }
    }

    componentDidMount() {
        this.props.dispatch(relationGroupsTableActions.getRelationGroups());
        this.props.dispatch(getRelationList.getRelationListHandler())

      
    }

 

    toggleModal(showModal) {

        this.setState({
            addRelationGroupState: showModal,
            relationToggle: false
        });
   

    }



    relationToggleHandler(showModal) {
      

        let addRelation = []
        this.props.relationListResponse.map(
            (relation, i) => {
                addRelation.push(
                    {
                        key: relation.assessor_name,
                        type: 'checkbox',
                        value: false,
                        valid: true,
                        elementConfig: {
                            name: relation.assessor_name,
                            label: relation.assessor_name,
                        },
                        validation: {
                            required: false,
                            message: ""
                        }
                    }
                )
            }
        )
        this.setState({
            addRelation: addRelation,
            relationToggle: true,
            addRelationGroupState: false
        })
    }

    toggleRelationGroup(showModal) {
        this.setState({
            relationToggle: false,
            addRelationGroupState: true,

        })
    }

    compareBy(key) {
        if (this.state.sortType == true) {
            return function (a, b) {
                if (a[key] !== null && b[key] !== null) {
                    if (typeof a[key] === 'number' && typeof b[key] === 'number') {
                        if (a[key] < b[key]) return -1;
                        if (a[key] > b[key]) return 1;
                        return 0;
                    }
                    else {
                        if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
                        if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
                        return 0;
                    }

                }
            };
        }

        if (this.state.sortType == false) {
            return function (a, b) {
                if (a[key] !== null && b[key] !== null) {
                   
                    if (typeof a[key] === 'number' && typeof b[key] === 'number') {
                        if (a[key] > b[key]) return -1;
                        if (a[key] < b[key]) return 1;
                        return 0;
                    }
                    else {
                        if (a[key].toLowerCase() > b[key].toLowerCase()) return -1;
                        if (a[key].toLowerCase() < b[key].toLowerCase()) return 1;
                        return 0;
                    }

                }
            };
        }
    }


    sortBy(columnKey, type, tableName) {
        this.setState({ sortType: type })
        if (tableName === 'relationGroupsTable') {
            const arrayCopy = this.state.relationGroupData === '' ? this.props.relationGroupsResponse : this.state.relationGroupData;
            arrayCopy.sort(this.compareBy(columnKey));
            this.setState({ relationGroupData: arrayCopy })
        }
    }

    relationGroupActionSelected(data) {
        let valueArray = []
        for (let j in data.sellerData.relation_list) {
            for (let i in this.props.relationListResponse) {
                if (this.props.relationListResponse[i].assessor_name === data.sellerData.relation_list[j]) {
                    valueArray.push(this.props.relationListResponse[i].id);
                }
            }
        }
      
        data.sellerData.relation_list = valueArray;

       

        this.props.dispatch(addRelationGroupAction.addData(data.sellerData));
    }

    resetData(data) {
        data.value = '';
        if (data.validation.required === true) {
            data.valid = false;
        }
    }

    toggleRelationGroupModal(showModal) {
       
        this.setState({
            addRelationGroupState: showModal
        })

        addRelationGroups.map(
            (data, i) => {
                this.resetData(data)
            }
        )

    }

    toggleEntireRelationModal(showModal) {
        this.setState({
            addRelationGroupState: showModal
        })
    }

    render() {

        const { loading, relationGroupsResponse, relationListResponse, relationGroupsLoading } = this.props;
        const relationGroupData = this.state.relationGroupData === '' ? relationGroupsResponse : this.state.relationGroupData;

        let buttonDataProp = [
            {
                id: 1,
                heading: "ADD A RELATION GROUP",
             
                toggler: this.toggleRelationGroupModal.bind(this),
                togglerModal: this.state.addRelationGroupState
            }
        ]
        return (
            <div>
                <NavBar />

                <div className="container custom-container my-5" >

                    <div>
                        <CommonBreadCrumb
                            data={[
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'RELATION GROUPS'
                                }
                            ]}
                        />
                    </div>

                    <div className="bg-green rounded-top position-relative animation-fade-in">
                        <p className="text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> RELATION GROUPS </p>
                        {
                            relationGroupsLoading &&
                            <i className="fas fa-spinner fa-spin text-white position-absolute spinner-position " ></i>
                        }
                       
                    </div>

                    <Settings
                        buttonData={buttonDataProp}
                        filter={false}
                        modal={this.toggleModal.bind(this)}
                        showModal={this.state.addRelationGroupState}
                    />
                    {
                        !relationGroupsLoading &&
                        <TableNew
                            data={relationGroupData}
                            columns={relationGroupstables.relationGroups}
                            showSlNo="true"
                            sortBy={(key) => this.sortBy(key, !this.state.sortType, 'relationGroupsTable')}
                            sortType={this.state.sortType}
                        />

                    }

                    {
                        this.state.addRelationGroupState &&
                        <ModalNew
                            relationToggle={this.relationToggleHandler.bind(this)}
                            showModal={this.state.addRelationGroupState}
                            modalName="nonSubmittableForm"
                            heading="Relation Groups"
                            formData={addRelationGroups}
                            toggleEntireModal={this.toggleEntireRelationModal.bind(this)}
                       
                        />
                    }
                    {
                        this.state.relationToggle &&
                        <ModalNew
                            modalName="inlineCheckbox1"
                            heading="Relation Groups"
                            showModal={this.state.relationToggle}
                            toggleRelationGroup={this.toggleRelationGroup.bind(this)}
                   
                            formData={this.state.addRelation}
                            action={(data) => { this.relationGroupActionSelected(data) }}
                            toggleEntireModal={this.toggleEntireRelationModal.bind(this)}
                        />
                    }
                </div>

            </div>
        );
    }
}

function mapStateToProps(state) {
  
    const { relationGroupsLoading, error } = state.relationGroupTable;

    const relationGroupsResponse = (!relationGroupsLoading && !error) ? state.relationGroupTable.data.data.results : '';


    const { RelationListLoading,  } = state.relationList;
    const relationListError = state.relationList.error;
    const relationListResponse = (!RelationListLoading && !relationListError) ? state.relationList.data.data.results : '';
    const relationListResponseCode = (!RelationListLoading && !relationListError) ? state.relationList.data.status : '';
    return {
        relationGroupsLoading,
        relationGroupsLoading,
        relationGroupsResponse,

        relationListResponse,
        relationListResponseCode,
    };
}

export default connect(mapStateToProps)(RelationGroups);


// WEBPACK FOOTER //
// ./src/_pages/Admin/RelationGroups/index.jsx